import styled from "@emotion/styled"

const Title = styled.div`
    margin-bottom: 12rem;
    font-weight: 700;
    font-size: 16rem;
    vertical-align: middle;
    color: #131416;
    height: 24rem;
    line-height: 24rem;
`

export default Title
